import type { Observable } from 'rxjs';
import type { CommerceLanding } from '../models/commerce-landing.model';

export abstract class CommerceLandingPort {
  /**
   * @param comercioSlug Route param `comercioSlug`
   * @param programaSlug Optional; when null/undefined/empty, pick landing with `programa_slug === ''` (see FLUJO doc).
   */
  abstract loadBySlug(
    comercioSlug: string,
    programaSlug?: string | null,
  ): Observable<CommerceLanding | null>;
}
